import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { Box, Button } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import messages from './messages';

export default function BackToAdminPanel() {
  const history = useHistory();

  return (
    <Box marginBottom={2}>
      <Button
        color="primary"
        startIcon={<ArrowBackIcon />}
        onClick={() => history.push('/admin-panel')}
      >
        <FormattedMessage {...messages.back} />
      </Button>
    </Box>
  );
}
